(() => {
  const ANIMATION_DURATION = 300;

  const initGroup = (group) => {
    if (!group || group.dataset.initialized === "true") {
      return;
    }

    const items = Array.from(group.querySelectorAll("[data-collapsible-item]"));
    if (!items.length) {
      return;
    }

    group.dataset.initialized = "true";

    const withPinnedSummaryPosition = (summary, runAnimations) => {
      if (!summary) {
        runAnimations();
        return;
      }

      const summaryTop = summary.getBoundingClientRect().top;
      const startedAt = performance.now();
      const maxDuration = ANIMATION_DURATION + 120;
      let rafId = null;

      const syncScroll = () => {
        const delta = summary.getBoundingClientRect().top - summaryTop;
        if (Math.abs(delta) > 0.5) {
          window.scrollBy({ top: delta, left: 0, behavior: "auto" });
        }
      };

      const tick = (now) => {
        syncScroll();

        if (now - startedAt < maxDuration) {
          rafId = window.requestAnimationFrame(tick);
          return;
        }

        rafId = null;
      };

      rafId = window.requestAnimationFrame(tick);

      runAnimations();

      window.setTimeout(() => {
        if (rafId !== null) {
          window.cancelAnimationFrame(rafId);
        }

        syncScroll();
      }, maxDuration);
    };

    const hasOpenItem = items.some((item) => item.open);
    if (!hasOpenItem) {
      items[0].setAttribute("open", "open");
    }

    items.forEach((item) => {
      const content = item.querySelector(".collapsible-richtext-babies__content");
      if (!content) return;

      if (item.open) {
        $(content).show();
      } else {
        $(content).hide();
      }
    });

    items.forEach((item) => {
      const summary = item.querySelector(".collapsible-richtext-babies__summary");
      const content = item.querySelector(".collapsible-richtext-babies__content");
      if (!summary || !content) {
        return;
      }

      summary.addEventListener("click", (event) => {
        event.preventDefault();

        const isOpen = item.hasAttribute("open");

        const closeItem = (targetItem) => {
          const targetContent = targetItem.querySelector(
            ".collapsible-richtext-babies__content"
          );
          if (!targetContent || !targetItem.hasAttribute("open")) {
            return;
          }

          $(targetContent)
            .stop(true, true)
            .slideUp(ANIMATION_DURATION, () => {
              targetItem.removeAttribute("open");
            });
        };

        withPinnedSummaryPosition(summary, () => {
          items.forEach((otherItem) => {
            if (otherItem !== item) {
              closeItem(otherItem);
            }
          });

          if (isOpen) {
            closeItem(item);
            return;
          }

          item.setAttribute("open", "open");
          $(content).stop(true, true).hide().slideDown(ANIMATION_DURATION);
        });
      });
    });
  };

  const initSection = (root) => {
    if (!root) {
      return;
    }

    root
      .querySelectorAll("[data-collapsible-group]")
      .forEach((group) => initGroup(group));
  };

  const initAll = () => {
    document
      .querySelectorAll(".js-collapsible-richtext-babies")
      .forEach((section) => initSection(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });
})();
